import React from 'react';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import { Capability } from '@utils/Permissions/Capabilities';

// ============================================================================
// ENLACES A OTRAS APPS — renglones del sidebar que abren una pestaña nueva.
//
// No son rutas: no se montan en el router ni salen en los breadcrumbs. Se pintan
// después de las rutas sueltas, y quién los ve lo decide su `capability` con el
// perfil en operación ("Ver como" los previsualiza igual que una pantalla).
// ============================================================================

export interface SidebarExternalLink {
    name: string;
    href: string;
    icon: React.FunctionComponent;
    capability: Capability;
}

/**
 * La supervisión de sucursales vive en su propia app (decisión de Irving,
 * 2026-10-06): el módulo de Supervisiones y el plan de Evaluaciones se cancelaron
 * y el admin solo la abre.
 */
export const SUPERVISION_URL = 'https://supervision.krispis.mx';

export const SIDEBAR_EXTERNAL_LINKS: SidebarExternalLink[] = [
    { name: 'Supervisión', href: SUPERVISION_URL, icon: FactCheckIcon, capability: Capability.SupervisionAppOpen }
];
